// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueResource from 'vue-resource';
import vuexStore from './store';
import Utils from './common/utils';
import 'mint-ui/lib/style.css';
import { MessageBox ,Toast, Indicator } from 'mint-ui'
// import VConsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new VConsole() // 初始化
// 引入vue-amap
// import VueAMap from 'vue-amap'

require('./assets/css/style.css')
// require('babel-polyfill')

// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';

import wx from 'weixin-js-sdk';

// Sentry.init({
//   dsn: 'https://c99e69f29e824e499ad6932651b87742@sentry.anlaiye.com/9',
//   integrations: [new Integrations.Vue({Vue, attachProps: true})],
// });

import {actions} from "./store/actions";



Vue.config.productionTip = false
Vue.use(VueResource)
Vue.prototype.$utils = Utils;
// mint-ui全局引用
Vue.prototype.$toast = Toast;
Vue.prototype.$messagebox = MessageBox;
Vue.prototype.$indicator = Indicator;
global.wx = wx;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];


var screenWidth = window.screen.width;
var fontS = 0;
// 移动端基准值计算（设计稿750px）
if (screenWidth <= 768) {
  fontS = screenWidth/750*100;
}
// PC端适配方案
else {
  fontS = 56; // 固定基准值
}
var html = document.getElementsByTagName('html')[0];
html.style.fontSize = fontS+'px';


/* eslint-disable no-new */
let vueMain = new Vue({
  el: '#app',
  router,
  store: vuexStore,
  template: '<App/>',
  components: { App }
})



// 页面标题
router.beforeEach((to, from,next) => {
  if (vuexStore.state.needRecord) {
    window.appScroll = 0;
    let exposureLog = localStorage.getItem('exposureLog');
    exposureLog = exposureLog ? JSON.parse(exposureLog) : [];
    if (exposureLog.length > 0) {
      let params = {
        logDetails: exposureLog,
        source: 3,
      };
      actions.postLogAdd(vueMain, params,function(res) {
        if (res.body.message === "Success" && res.body.result) {
          localStorage.setItem('lastLogTime', new Date().getTime());
          localStorage.setItem('exposureLog', JSON.stringify([]));
        }
      }, function (){

      })
    }
    // if (vuexStore.state.recordPage)
  }
  vuexStore.commit('changeRecordState', false);
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})

// 全局路由守卫
router.afterEach((to, from) => {
  MessageBox.close();
  Indicator.close();
})
export default vueMain;




// WEBPACK FOOTER //
// ./src/main.js